module.exports = __webpack_public_path__ + "static/media/sgd-1.7d7aa3b6.png";